import { createRouter, createWebHistory } from 'vue-router';

import { frontendURL } from '../helper/URLHelper';
import dashboard from './dashboard/dashboard.routes';
import store from 'dashboard/store';
import { validateLoggedInRoutes } from '../helper/routeHelpers';
import AnalyticsHelper from '../helper/AnalyticsHelper';

const routes = [...dashboard.routes];

export const router = createRouter({ history: createWebHistory(), routes });

export const validateAuthenticateRoutePermission = (to, next) => {
  const { isLoggedIn, getCurrentUser: user } = store.getters;

  if (!isLoggedIn) {
    window.location.assign('/app/login');
    return '';
  }

  const accountId = Number(to.params?.accountId || user.account_id || 0);
  if (!accountId) {
    return next();
  }
  const accountRootPath = accountId
    ? frontendURL(`accounts/${accountId}`)
    : null;
  const isAccountRootPath =
    !!accountRootPath &&
    (to.path === accountRootPath || to.path === `${accountRootPath}/`);
  const isUnmatchedRoute = !to.matched || to.matched.length === 0;

  // Important: some valid intermediary routes can temporarily have no name.
  // Redirect to dashboard only for unmatched routes or pure account root.
  if (!to.name && (isUnmatchedRoute || isAccountRootPath)) {
    return next(frontendURL(`accounts/${accountId}/dashboard`));
  }

  if (!to.name) {
    return next();
  }

  const nextRoute = validateLoggedInRoutes(
    to,
    store.getters.getCurrentUser,
    store.getters
  );
  return nextRoute ? next(frontendURL(nextRoute)) : next();
};

export const initalizeRouter = () => {
  const userAuthentication = store.dispatch('setUser');

  router.beforeEach((to, _from, next) => {
    AnalyticsHelper.page(to.name || '', {
      path: to.path,
      name: to.name,
    });

    userAuthentication.then(() => {
      return validateAuthenticateRoutePermission(to, next, store);
    });
  });
};

export default router;
